export default {"src":"/_next/static/media/icon-airbnb.00d758f8.svg","height":75,"width":75};